import { Box, List, ListItem, Typography } from '@coolblue-development/freddy';
import { useTranslation } from '@i18n/useTranslation';

const ModalContent = () => {
  const { t } = useTranslation('webshop.business.leasing.modal');

  return (
    <Box>
      <Typography variant='body' mb={300}>
        {t('body.intro')}
      </Typography>

      <Typography variant='h3'>{t('titles.requirements')}</Typography>
      <Typography variant='body' mb={300}>
        {t('body.requirements')}
      </Typography>

      <Typography variant='h3' mb={200}>
        {t('titles.steps')}
      </Typography>
      <List component='ol' marker='emphasised'>
        {[1, 2, 3].map(step => (
          <ListItem key={step}>{t(`body.steps.${step}`)}</ListItem>
        ))}
      </List>
    </Box>
  );
};

export default ModalContent;
